import SkillzStyle from 'SkillzStyle';
import {StyleSheet} from 'react-native';

export const createStyles = (gameTheme: any, isDarkTheme: boolean) => {
  const {
    textColorPrimary,
    textColorTertiary,
    fontBold,
    viewSecondaryColor,
    textColorSecondary,
    playButtonGradient,
  } = gameTheme ?? {};
  return StyleSheet.create({
    keyboardAvoidingContainer: {
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    emailVerificationContainer: {
      width: '100%',
      alignSelf: 'center',
    },
    verificationMessageText: {
      fontSize: 16,
      fontStyle: 'normal',
      ...SkillzStyle.fullStyles.fontBold,
      ...textColorTertiary,
      textAlign: 'center',
    },
    emailAddressText: {
      fontSize: 16,
      fontStyle: 'normal',
      ...SkillzStyle.fullStyles.fontBold,
      lineHeight: 20,
      ...textColorPrimary,
      textAlign: 'center',
    },
    editIcon: {
      height: 20,
      width: 20,
      marginLeft: 4,
      marginTop: -2,
    },
    passwordInput: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 7,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: playButtonGradient[0],
      height: 56,
      marginTop: 32,
      backgroundColor: isDarkTheme ? 'rgba(0, 0, 0, 0.25)' : viewSecondaryColor?.backgroundColor,
    },
    forgotPasswordText: {
      fontSize: 16,
      ...textColorPrimary,
      ...SkillzStyle.fullStyles.fontExtraBold,
      fontStyle: 'normal',
      textDecorationLine: 'underline',
      marginTop: 20,
      textAlign: 'center',
    },
    otpContainerWithBorder: {
      borderColor: 'transparent',
      backgroundColor: isDarkTheme ? 'rgba(0, 0, 0, 0.25)' : viewSecondaryColor?.backgroundColor,
      opacity: 0.86,
      borderWidth: 1,
      borderRadius: 12,
      width: 56,
      height: 56,
      flex: 1,
      justifyContent: 'center',
      marginHorizontal: 2,
    },
    countdownText: {
      fontSize: 16,
      ...textColorPrimary,
      ...fontBold,
      fontStyle: 'normal',
      textDecorationLine: 'underline',
      marginTop: 20,
      textAlign: 'center',
    },
    countdownTextDisabled: {
      opacity: 0.5,
      textDecorationLine: 'none',
    },
    newMessageHeader: {
      fontSize: 28,
      lineHeight: 38,
      ...fontBold,
      ...textColorPrimary,
      textAlign: 'center',
      marginBottom: 16,
    },
    otpSelected: {
      borderColor: playButtonGradient[0],
      borderWidth: 2,
    },
    otpInput: {
      color: isDarkTheme ? textColorPrimary.color : textColorSecondary.color,
      fontSize: 20,
      fontFamily: 'OpenSans-Bold',
      textAlign: 'center',
      textAlignVertical: 'center',
    },
    icon: {
      marginRight: 8,
      marginLeft: 8,
      tintColor: isDarkTheme ? '#ffffff70' : 'rgba(0,0,0,.3)',
      height: 24,
      width: 24,
    },
    visible: {
      opacity: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    hidden: {
      opacity: 0,
      position: 'absolute',
      top: -1000,
      left: -1000,
      height: 0,
      overflow: 'hidden',
    },
    bannerContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    passwordTextInput: {
      width: '80%',
    },
    passwordTextInputDark: {
      color: textColorPrimary?.color,
    },
    passwordTextInputLight: {
      color: textColorSecondary?.color,
    },
    forgotPasswordTextWithColor: {
      fontSize: 16,
      ...textColorPrimary,
      ...SkillzStyle.fullStyles.fontExtraBold,
      fontStyle: 'normal',
      textDecorationLine: 'underline',
      marginTop: 20,
      textAlign: 'center',
      color: textColorPrimary?.color,
    },
    otpSelectedWithBorder: {
      borderColor: playButtonGradient?.[0],
      borderWidth: 2,
    },
    placeholderColorDark: {
      color: textColorPrimary?.color,
    },
    placeholderColorLight: {
      color: textColorSecondary?.color,
    },
    checkboxColorDark: {
      color: 'white',
    },
    checkboxColorLight: {
      backgroundColor: viewSecondaryColor?.backgroundColor,
    },
  });
};
